import React, { useEffect, useState, useRef } from "react";
import { decodeToken, SaveNGetFtInfo } from "../service/ApiService";

function ProcessSSOLogin({ token }) {
  const hasRun = useRef(false);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [decodedData, setDecodedData] = useState(null);

  const SSBasedId = process.env.REACT_APP_SSO_RedBase_URL;
  const SSOclientId = process.env.REACT_APP_SSO_ClientId;

  useEffect(() => {
    if (hasRun.current) return;
    hasRun.current = true;

    if (!token) {
      setError("Token is missing");
      setLoading(false);
      return;
    }

    const processSSO = async () => {
      try {
        /* ========= STEP 1: DECODE TOKEN ========= */
        const { data } = await decodeToken(token);

        const body = data?.body;
        const status = data?.statusCode;

        if (!body) throw new Error("Invalid token response");

        setDecodedData(body);

        /* ========= STEP 2: HANDLE ERROR ========= */
         if (status === 500 && body?.error === "jwt expired") {
          console.log("Token expired");
          window.location.href = `${SSBasedId}?clientId=${SSOclientId}`;
          return;
        }

        if (status === 401) {
          window.location.href = `${SSBasedId}?clientId=${SSOclientId}`;
          return;
        }

        if (status === 500) {
          window.location.href = `${SSBasedId}?clientId=${SSOclientId}`;
          return;
        }

        if (status !== 200) {
           window.location.href = `${SSBasedId}?clientId=${SSOclientId}`;
          return;
        }

        const payload = {
  Name: body?.name || "",
  MobileNo: body?.mobile || "",
  Email: body?.email || "",
  bcode: body?.["custom:BCode"] || "",
  logintype: body?.["custom:userType"] || "",
};

console.log("Final Payload:", payload);

const FTResult = await SaveNGetFtInfo(payload);

        console.log("FTResult:", FTResult);

        if (!FTResult?.Fyn_Token || !FTResult?.Fyn_RedirectUrl) {
          throw new Error("Invalid FTResult data");
        }

        /* ========= STEP 4: REDIRECT ========= */
        const finalUrl = `${FTResult.Fyn_RedirectUrl}&Flag1=1&lob=Dashboard`;

        console.log("Redirecting:", finalUrl);

        window.location.href = finalUrl;

      } catch (err) {
        console.error("SSO Error:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    processSSO();
  }, [token, SSBasedId, SSOclientId]);
  return null;


}

export default ProcessSSOLogin;